module.exports = __webpack_public_path__ + "static/necro-ac23d672320a51a4b3a52f515a15642c.png";